<template>
    <div id="searchResults" class="search-results-container" :class="{'quick-search': searchType === 'Smart'}">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <searchResultsMenu :countLoader="countLoader" />
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="content-with-sidebar" >
                    <div class="field-error-message error-large" v-if="serviceError">
                        Unable to load patent data
                        <div class="error-code">
                        {{serviceError}}
                        </div>
                    </div>
                    <div v-if="!patentResults && patentTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                    <dataTable class="dataTable" :table="patentTable" fromPage="patents" ref="dataTable" v-if="patentResults" />
                </div>
            </div>
        </div>

        <!-- Export -->
        <exportModule ref="exportModule" fromPage="patents" />
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';
import Charts from '@/components/global/Charts.vue';
import facets from '@/components/global/facets.vue';
import searchResultsMenu from '@/components/global/searchResultsMenu.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'patents',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      navigationTabs,
      facets,
      Charts,
      searchResultsMenu,
      exportModule
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'editSearchCriteria',
            'searchMeta',
            'patentResults',
            'patentsCount'
        ]),
    },
    watch: {
      patentResults: function () {
        if (this.patentResults !== null && this.patentResults.results.length > 0) {
          this.getPatentsCount();
        }
      }
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            serviceError: null,
            countLoader: false
        };
    },
    mounted () {
        // console.log(this.$route);
        // check if search ID exists, otherwise redirect to home page
        // if (window.readCookie('searchMode')) {
        //     this.setSearchMode('advanced-search');
        // } else {
        //     this.setSearchMode('');
        // }

        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            if (!this.patentResults) {
                this.patentTable.isLoading = true;
                this.countLoader = true;
                if (this.$route.query.sort_field) {
                    this.patentTable.sortField = this.$route.query.sort_field;
                }
                if (this.$route.query.sort_order) {
                    this.patentTable.sortOrder = this.$route.query.sort_order;
                }
                if (this.$route.query) {
                    this.parseFacetFiltersFromURL();
                }
                this.getPatents(false);
            } else {
                if (this.patentResults.meta.sort_field) {
                    this.patentTable.sortField = this.patentResults.meta.sort_field;
                    this.patentTable.sortOrder = this.patentResults.meta.sort_order;
                    let facetToQueryStr = this.$refs.facets.generateQueryString();

                    facetToQueryStr['sort_field'] = this.patentTable.sortField;
                    facetToQueryStr['sort_order'] = this.patentTable.sortOrder;
                    this.$router.push({ query: facetToQueryStr}).catch(err => {});
                }
            }
        }

        this.setFullscreen(true);
        setTimeout(() => {
            bus.$emit('update:resize');
        }, 1);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode'
        ]),
        getPatentsCount() {
            var parsedCriteria = window.parseCriteria(this.searchCriteria, {isSubmitForm: false}),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria),
                searchParam = {
                    offset: this.patentTable.offset,
                    limit: this.patentTable.limit,
                    facet_filters: this.searchFacetCriteria,
                    criteria: criteria,
                    is_shared: this.$route.query['shared'] ? true : false,
                    CoreProjSortField: 'fiscal_year', // hardcoded to fetch top 10000 patents
                    CoreProjSortOrder: 'desc',
                    cache_id: this.patentResults.meta.properties.CacheId
                },
                callback = (data) => {
                    this.patentResults.meta.total = data.meta.total;
                    this.countLoader = false;
                };

            if (this.$route.params.search_id) {
                searchParam['search_id'] = this.$route.params.search_id;
            }

            this.countLoader = true;
            window.fetchPatentsCount(searchParam, callback);
        },
        setSortDetails ($event, selectedSortColumn) {
            this.patentTable.isLoading = true;
            var selectedSortField = this.getFieldNameFromSettings(selectedSortColumn),
                facetToQueryStr;

            if (this.patentTable.sortField === selectedSortField) {
                this.patentTable.sortOrder = (this.patentTable.sortOrder === 'asc' ? 'desc' : 'asc');
            } else {
                this.patentTable.sortOrder = selectedSortColumn.sortOrder;
            }
            this.patentTable.sortField = selectedSortField;
            this.patentTable.offset = 0;
            window.scrollTo(0, 0);

            facetToQueryStr = this.$refs.facets.generateQueryString();
            facetToQueryStr['sort_field'] = this.patentTable.sortField;
            facetToQueryStr['sort_order'] = this.patentTable.sortOrder;

            this.$router.push({ query: facetToQueryStr});
			gtag('event','Click', {
				'event_category': 'Patent Results',
				'event_label': 'Patent Results - sorted on ' + this.patentTable.sortField + ' (' + this.patentTable.sortOrder + ')',
				'value': 'Patent Results - sorted on ' + this.patentTable.sortField + ' (' + this.patentTable.sortOrder + ')'
			});	
            this.getPatents(false);
        },
        setProjectPageNumber (requestedPage) {
            if (requestedPage === this.$options.name) {
                if (this.$store.state.patentResults && this.$store.state.patentResults.meta.total > this.patentTable.offset + this.patentTable.limit) {
                    this.patentTable.loadingMoreData = true;
                    this.patentTable.offset += this.patentTable.limit;
                    this.getPatents(false);
                }
            }
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam = {
                "search_id": this.$route.params.search_id,
                "cache_id": this.patentResults.meta.properties.CacheId,
                "facet_filters": this.$refs.facets.searchFacetCriteria,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "offset": 0,
                "limit": 0,
                "sort_field": this.patentTable.sortField,
                "sort_order": this.patentTable.sortOrder
            }
            this.getExportFile(searchParam, callback);
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

</style>